module.exports = __webpack_public_path__ + "img/icon-sms.53e67158.svg";